const billing = {
	invoices: {
		invoice_dialog: {
			actions: {
				download: "Herunterladen",
				pay: "Bezahlen",
			},
			invoice_date: "Rechnungsdatum",
			pay_before: "Zahlung bis",
			status: "Status",
			table: {
				date: "Datum",
				description: "Beschreibung",
				price: "Betrag exkl. MwSt.",
				quantity: "Menge",
				total_row: {
					price_with_vat: "Betrag inkl. MwSt. €",
					price_without_vat: "Betrag exkl. MwSt. €",
					vat_percentage: "21% MwSt. €",
				},
			},
		},
		title: "Rechnungen",
	},
	orders: {
		table: {
			company: "Unternehmen",
			debtor_code: "Kundennummer",
			free: "Frei",
			order_date: "Datum der Erstellung",
			order_label: "Label",
			order_number: "Bestellnummer",
			order_status: "Status der Bestellung",
			order_type: {
				dadup: "daDup",
				domain: "Domänennamen",
				label: "Produkte",
				pbs: "PBS",
				pbs_free: "PBS gratis",
				pbs_sync: "PBS sync",
				qemu: "VPS",
			},
			other: "Sonstige",
			reset: "Zurücksetzen",
			search: "Suchen",
			status: {
				active: "Aktiv",
				cancellation_pending: "Annullierung im Gange",
				cancelled: "Abgebrochen",
				completed: "Vollendet",
				ended: "Beended",
				failed: "Gescheitert",
				label: "Zustände",
				pending: "In Erwartung",
				replaced: "Ersetzt",
			},
			sub_row: {
				alert_description:
					"Dieser Dienst wird im Nachhinein abgerechnet. Klicken Sie auf „Anzeigen“ an der rechten Seite für Ihren aktuellen Verbrauch.",
				expired_at: "Abgelaufen am",
				order_done_by: "Bestellung durch",
				order_purchase_number: "Bestellnummer",
				price: "Betrag ohne MwSt.",
				product: "Produkt",
				quantity: "Anzahl",
				replaced_by_order: "Ersetzt durch Bestellung",
				replaces_order: "Ersetzt Bestellung",
				title: "Bestellung",
				unit: {
					mb: "MB",
					unit_month: "Monat",
					x: "X",
				},
			},
			total_price: "Gesamtbetrag",
		},
	},
};

export default billing;
